import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/public/SiteFooter";
import { useSite } from "@/context/SiteContext";
import { Faq, Pricing } from "@/components/landing/MoreSections";
import { DHero, Benefits, Steps, DCta } from "@/pages/DriversPage";
import { Store } from "lucide-react";
import PartnerEnquiry from "@/components/PartnerEnquiry";

const SECTIONS = {
  hero: ({ d }) => <DHero d={d} tid="partners" Icon={Store} />,
  benefits: ({ d }) => <Benefits d={d} tid="partners" />,
  pricing: ({ d }) => <Pricing c={{ pricing: d.pricing }} />,
  steps: ({ d }) => <Steps d={d} tid="partners" />,
  faq: ({ d }) => <Faq c={{ faq: d.faq }} />,
  enquiry: PartnerEnquiry,
  cta: ({ d }) => <DCta d={d} tid="partners" />,
};

export default function PartnersPage() {
  const { content } = useSite();
  const d = content?.partners_page;
  if (!d) return <div className="public-site min-h-screen bg-navy"><Navbar dark /></div>;
  const visible = (d.sections || []).filter((s) => s.enabled && SECTIONS[s.id]);
  return (
    <div className="public-site min-h-screen bg-white" data-testid="partners-page">
      <Navbar dark={visible[0]?.id === "hero"} />
      {visible.map((s) => { const Comp = SECTIONS[s.id]; return <Comp key={s.id} d={d} />; })}
      <SiteFooter />
    </div>
  );
}
